module.exports = __webpack_public_path__ + "img/zsh.649cf2c2.png";